import React from 'react';
import Carousel from './Carousel';

import { Helmet } from 'react-helmet';
import PopularResorts from '../pages/PopularResorts';
import PopularLocations from '../pages/PopularLocations';
import HotInternationalRoutes from '../pages/HotInternationalRoutes';
import CustomerReviews from '../pages/CustomerReviews';
import ExperienceSection from '../pages/ExperienceSection';
import TrendingArticles from '../pages/TrendingArticles';


const HeroSection = () => {

  return (


    <div className="th-hero-wrapper hero-1" id="hero">



        <Carousel/>
        <PopularResorts/>
        <PopularLocations/>
<HotInternationalRoutes/>
<CustomerReviews/>
<ExperienceSection/>
<TrendingArticles/>
    </div>
  );
};

export default HeroSection;
